var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('dialog-conversation-history',{attrs:{"sender_name":_vm.sender_name}}),_c('dialog-block-customer'),_c('dialog-change-request-support'),_c('dialog-create-m-a-d-template'),_c('dialog-update-m-a-d-template'),_c('dialog-m-a-d-template'),_c('dialog-create-quick-response'),_c('dialog-import-agent-quick-response')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }